import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { BaseIcon } from './index.elements';
import { MQ } from '@css/constants';

type Props = {
  height?: number
  width?: number
}

export const Icon = styled(BaseIcon)<Props>(props => css`
  height: ${props.height || 40}px;
  width: ${props.width || 181}px;
`);

export const Colored = styled('g')<{ whiteOnMobile: boolean }>(props => css`
  ${MQ.SMALL_SCREENS} {
    display: ${props.whiteOnMobile ? 'none' : 'block'};
  }
`);

export const BlackNWhite = styled('g')<{ whiteOnMobile: boolean }>(props => css`
  display: none;

  ${MQ.SMALL_SCREENS} {
    display: ${props.whiteOnMobile ? 'block' : 'none'};
  }
`);
